import AddShoppingListProductModal from './AddShoppingListProductModal';

export default AddShoppingListProductModal;
